// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__HUVia","contain":"styles_contain__2l1j1"};